module.exports = __webpack_public_path__ + "static/media/21ECLAC9.53804607.jpg";